import React, { useState } from 'react';
import { ProgressBar } from "@progress/kendo-react-progressbars";
import useSocket from '../../socket/useSocket';
import { LOCALSTORAGE_KEY, SOCKET_ACTION, SOCKET_EVENTS } from '../../constant/constant';

const ProgressBarPopup = ({ ModuleID }) => {
    
    const [show, setShow] = useState({
        okButton: false,
        progressBarPopup: false,
        error: false
    });
    const [progressData, setProgressData] = useState({
        message: '',
        progress: 0,
    });

    useSocket(SOCKET_EVENTS.onProgressUpdate, (socketData) => {
        let userId = localStorage.getItem(LOCALSTORAGE_KEY.user_id).replace(/"/g, '');
        if (socketData.module != ModuleID) return;
        if(socketData.userId && socketData.userId.length > 0 && socketData.userId != userId) return;
        switch (socketData.action) {
            case SOCKET_ACTION.PROGRESS:
                onprogress(socketData.data);
                break;
            case SOCKET_ACTION.PROGRESS_BAR_ERROR:
                onError(socketData.data);
                break;
            default:
                break;
        }
    })

    const onprogress = (data) => {
        setProgressData({
            message: data.message,
            progress: data.progress,
        });
        setShow({
            okButton: data.progress == 100 ? true : false,
            progressBarPopup: true,
        });
    }

    const onError = (data) => {
        setProgressData({
            message: data?.message || 'Internal Server Error',
            progress: 90
        });
        setShow({
            okButton: true,
            progressBarPopup: true,
            error: true
        });
    };

    return (
        show.progressBarPopup && <div id='myProgressBar'>
            <div className='myProgressBarBox'>
                <ProgressBar
                    label={(props) => {
                        return <strong>{props.value}%</strong>;
                    }}
                    labelPlacement='center'
                    progressStyle={{ backgroundColor: show.error ? "red" : "green" }}
                    value={progressData.progress}
                    style={{ width: "360px" }}
                />
                <div className='message'>
                    <p className={show.error ? 'text-danger' : 'text-success'}>{progressData.message}</p>
                </div>
                {show.okButton && <button onClick={() => { setShow({ ...show, progressBarPopup: false }); }} style={{ width: "50px" }} className={`k-button k-button-md k-rounded-md k-button-solid k-button-solid-base bg-${show.error ? 'danger' : 'success'} text-white`} >Ok</button>}
            </div>
        </div>
    );
}

export default ProgressBarPopup;
